// utils
import ResidualField from './ResidualField.interstate';
import AdjustedResidualDisplay from './AdjustedResidualDisplay';
import type { DealTabs } from '@makemydeal/dr-shared-types';
import { useAdjustedResidualInputProps } from './hooks/useAdjustedResidualInputProps';

const AdjustedResidualField = ({ tab }: { tab?: DealTabs }) => {
    const { isReadOnlyDisplay, inputProps } = useAdjustedResidualInputProps();

    if (isReadOnlyDisplay) {
        return <AdjustedResidualDisplay />;
    }

    return <ResidualField inputProps={inputProps} fieldType="adjustedResidual" tab={tab} />;
};

export default AdjustedResidualField;
